import React from 'react';

export default function EditButton({ section, onEdit, label = 'Edit' }) {
  if (!onEdit) return null;

  return (
    <button
      className="edit-btn"
      onClick={() => onEdit(section)}
      aria-label={`${label} ${section}`}
    >
      <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 14.5V18h3.5l9.8-9.8-3.5-3.5L2 14.5zm17.7-9.3a1 1 0 0 0 0-1.4l-2.5-2.5a1 1 0 0 0-1.4 0l-1.8 1.8 3.5 3.5 1.8-1.8z"/>
      </svg>
    </button>
  );
}
